import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BannerType } from '@go-modules/enums/ngx-banner-type';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'ngx-banner',
	standalone: true,
	templateUrl: './ngx-banner.component.html',
	styleUrls: ['./ngx-banner.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		TranslateModule
	]
})
export class NgxBannerComponent {
	public readonly bannerType = BannerType;

	@Input() public type: BannerType = BannerType.Neutral;
	@Input() public dismissable = false;
	@Output() public onBannerDismissed = new EventEmitter<void>();
}
